// extracted by mini-css-extract-plugin
export default {"badge":"Zp1OthKRiQ8au6CjYctu"};